/** Format bytes to human-readable string */
export const formatBytes = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/** Format duration in ms to human-readable string */
export const formatDuration = (ms: number): string => {
  if (ms < 1000) return `${ms}ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;
  return `${Math.floor(ms / 60000)}m ${Math.floor((ms % 60000) / 1000)}s`;
};

/** Returns a timestamp string like "14:32:05" */
export const timestamp = (): string => {
  return new Date().toLocaleTimeString('en-US', { hour12: false });
};

/** Clamp a number between min and max */
export const clamp = (val: number, min: number, max: number): number =>
  Math.max(min, Math.min(max, val));

/** Count lines in a string */
export const lineCount = (code: string): number =>
  code.split('\n').length;

/** Truncate string to max length with ellipsis */
export const truncate = (str: string, max: number): string =>
  str.length > max ? `${str.slice(0, max)}…` : str;

/** Generate a unique ID */
export const uid = (): string =>
  Math.random().toString(36).slice(2, 9);
